export function applyInstanceMixins(toIns: any, fromIns: Array<any>): any {
  const getPluginInstanceMethods = (instance: any) => {
    const proto = Object.getPrototypeOf(instance)
    const names = Object.getOwnPropertyNames(proto)
    return names.filter(name => {
      return typeof instance[name] === 'function' && name !== 'constructor'
    })
  }

  fromIns.map(instance => {
    const methods = getPluginInstanceMethods(instance)

    methods.forEach(method => {
      if (toIns[method]) {
        console.warn(`'${method}' is existed, prev is replaced.`)
      }
      toIns[method] = (...args: Array<any>) => instance[method](...args)
    })

    return null
  })

  return toIns
}
